export default __webpack_public_path__ + "static/media/checked.3e9e1ed5.svg";